import React from 'react';
import { useHistory } from 'react-router-dom';
import { Card, CardHeader, IconButton, makeStyles } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { formatMoney } from '../../../utils/common';
import {
  XMEI_PRIMARY_COLOR,
  XMEI_SECONDARY_COLOR,
} from '../../../consts/common';

const useStyles = makeStyles({
  card: {
    marginTop: 15,
    paddingTop: 10,
    paddingHorizontal: 10,
    width: '100%',
    paddingBottom: 10,
  },
  container: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  planName: {
    fontWeight: 'bold',
    fontSize: 20,
    color: '#FFF',
    textAlign: 'center',
  },
  planValue: {
    fontWeight: 'bold',
    fontSize: 18,
    marginTop: 10,
    alignSelf: 'center',
    textAlign: 'center',
  },
  planInterval: {
    fontWeight: 'bold',
    fontSize: 16,
    color: '#FFF',
    alignSelf: 'center',
  },
  planDescription: {
    fontWeight: 'bold',
    fontSize: 15,
    alignSelf: 'center',
    marginTop: 10,
    color: '#FFF',
    textAlign: 'center',
  },
  currentPlan: {
    textAlign: 'right',
    fontWeight: 'bold',
    fontSize: 15,
    color: '#FFF',
    marginTop: 10,
    marginRight: 5,
  },
  next: {
    backgroundColor: XMEI_SECONDARY_COLOR,
    color: '#FFF',
    fontWeight: 'bold',
    height: '40px',
    '&:hover': {
      backgroundColor: XMEI_PRIMARY_COLOR,
    },
  },
});

function CardPlanosAssinatura(props) {
  const classes = useStyles(props);
  const history = useHistory();
  const valueString = `${formatMoney(parseFloat(props.plan.valor) / 100)}/mês`;

  function handleClickNext() {
    const route = '/payment-card';

    history.push({
      pathname: route,
      state: {
        type: 'Signature',
        signaturePlan: props.plan,
        openingCompany: false,
        user: props.user,
        portal: props.portal,
      },
    });
  }

  return (
    <div>
      <Card>
        <CardHeader
          title={`${props.plan.nome} - ${valueString}`}
          subheader={props.planDescription}
          action={
            <IconButton
              className={classes.next}
              aria-label="settings"
              onClick={handleClickNext}
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </IconButton>
          }
        />
      </Card>
    </div>
  );
}

export default CardPlanosAssinatura;
